import React from 'react'
import EstimationManagement from './abstract/EstimationManagement'
import PageHeader from '../../components/PageHeader'

class EstimationCreate extends EstimationManagement {
  onPageMenuClicked (name) {
    switch (name) {
      case 'back':
        this.props.history.push('/company_user/estimation/' + this.estimationType)
        break
      case 'blankCreate':
        this.props.history.push('/company_user/estimation/' + this.estimationType + '/add/blank')
        break
      case 'copyRealtoReal':
        this.props.history.push('/company_user/estimation/real')
        break
      case 'copyTemplateToReal':
        this.props.history.push('/company_user/estimation/template')
        break
      default:
        break
    }
  }
  render () {
    const estimationTypeCaption = this.isTemplate ? '雛型' : '見積書'
    const pageHeaderMain = estimationTypeCaption + 'の新規作成'
    const pageHeaderSub = 'こちらから' + estimationTypeCaption + 'の新規作成ができます。'
    return (
      <div>
        <PageHeader title={pageHeaderMain} sub={pageHeaderSub} history={this.props.history}>
          <ul className='nav nav-pills kw-page-actions'>
            <li className='kw-btn-area'>
              <button onClick={(e) => this.onPageMenuClicked('back', e)} rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary'>
                <i className='icon-arrow-left icon-large' /><span>戻る</span>
              </button>
            </li>
          </ul>
        </PageHeader>
        <section className='page container'>
          <div className='box kw-create-area'>
            <div className='box-header'>
              <i className='icon-share' />
              <h5>{estimationTypeCaption}の新規作成</h5>
            </div>
            <div className='box-content'>
              <p>こちらでは、以下の方法を選択し{estimationTypeCaption}の新規作成ができます。</p>
              <div className='visible-phone text-center'>
                <button className='btn' onClick={(e) => this.onPageMenuClicked('blankCreate', e)} ><i className='icon-list-alt' /> 白紙状態から新規作成</button><br /><br />
                <button className='btn' onClick={(e) => this.onPageMenuClicked('copyRealtoReal', e)}><i className='icon-list-alt' /> 見積書をコピーして新規作成</button><br /><br />
                <button className='btn' onClick={(e) => this.onPageMenuClicked('copyTemplateToReal', e)}><i className='icon-hdd' /> 雛型をコピーして新規作成</button>
              </div>
              <table className='hidden-phone kw-create-tbl'>
                <tbody>
                  <tr>
                    <th><button className='btn' onClick={(e) => this.onPageMenuClicked('blankCreate', e)}><i className='icon-list-alt' /> 白紙状態から新規作成</button></th>
                    <td>　・・・　</td>
                    <td><div className='kw-create-msg'>白紙状態から、新しい{estimationTypeCaption}を作成できます。</div></td>
                  </tr>
                  <tr>
                    <th><button className='btn' onClick={(e) => this.onPageMenuClicked('copyRealtoReal', e)}><i className='icon-list-alt' /> 見積書をコピーして新規作成</button></th>
                    <td>　・・・　</td>
                    <td><div className='kw-create-msg'>既存の見積書をコピーして、新しい{estimationTypeCaption}を作成できます。<br /><br />
                      <strong>既存の見積書を選択した際に表示される見積書の詳細画面上部の「再利用」ボタンより新規作成を行ってください。</strong></div></td>
                  </tr>
                  <tr>
                    <th><button className='btn' onClick={(e) => this.onPageMenuClicked('copyTemplateToReal', e)}><i className='icon-hdd' /> 雛型をコピーして新規作成</button></th>
                    <td>　・・・　</td>
                    <td><div className='kw-create-msg'>雛型をコピーして、新しい{estimationTypeCaption}を作成できます。<br /><br />
                      <strong>雛型を選択した際に表示される雛型の詳細画面上部の「再利用」ボタンより新規作成を行ってください。</strong></div></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

export default EstimationCreate



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/EstimationCreate.js